import { AppHelper } from "../../appHelper";
import { Helper } from "../../core/util/helper";
import { FieldInstance } from "../../core/components/field";
import { DropDownList } from "../../core/components/dropDownList";
import { NodaPeriodeNumericTextBox } from "../../core/components/nodaPeriodeNumericTextBox";
import { ComponentHelper } from "../../core/util/componentHelper";
import { Region } from "../../core/components/region";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import GridLayout, { GridLayoutConfig } from "../../core/components/gridLayout";
import { DatePicker } from "../../core/components/datePicker";
import { Menu, MenuEntry, EntryType } from "../../core/components/menu";
import { SheetEventType } from "../../../siteManagement/sheet";
import { General } from "../../../siteManagement/general";
import { CheckBox } from "../../core/components/checkBox";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { AppBaseProps, Context, Entity } from "../../core/components/commonApp";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react"

export default class EditRecurrenceSchemaVersion extends React.Component<EditReccurenceSchemaProps, any> {
    common = new AppHelper();
    private factory = ComponentHelper.createFactory();
    workPackagesDs = [];
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = false;
    deleteEnabled: boolean = false;
    isDeleted: boolean;
    translations: StringKeyDictionary<string> = null;
    private sheet;
    private rule: GridLayoutConfig = [
        {
            breakPoint: 0,
            size: "12/12"
        },
        {
            breakPoint: 1,
            size: "6/12"
        },
        {
            breakPoint: 2,
            size: "6/12"
        }
    ];
    menuDataSource: Array<MenuEntry> = [{ type: EntryType.Save }];
    constructor(props) {
        super(props);
        this.common.init(this);
        this.sheet = General.Sheet.Manager.getTopMostSheet();
    }
    private checkValidFrom = () => {
        if (this.props.entity.TriggerOnInit) {
            return (this.props.entity.PrevVersionLastExecuted < this.props.entity.NewVersionValidFrom);

        } else {
            return true;
        }
    }

    save = () => {
        if (this.checkValidFrom()) {
            this.common.setEntityDirtyState(false);
            this.sheet.trigger(SheetEventType.SavedSuccessfully, { data: this.props.entity });
        } else {
            NotificationHelper.showInfoMessage(Helper.getTranslation("WebCRM.Tasks.Task.Schema.NewVersion.InvalidNewDate"));
        }

    }

    private getDatePickerScheduledFor = () => {
        const props = this.factory.getDefaultDatePickerProps();
        props.disabled = false;
        props.value = this.props.entity.NewVersionValidFrom;
        props.onChange = this.onComponentChange;
        props.field.model = "NewVersionValidFrom";
        props.field.clearTime = true;
        props.required= true;
        return props;
    }
    private getTriggerOnInitProps = () => {
        const props = this.factory.getDefaultCheckBoxProps();
        props.disabled = false
        props.value = this.props.entity.TriggerOnInit;
        props.onChange = this.onComponentChange;
        props.field.model = "TriggerOnInit";
        return props;
    }
    private getStartingPointProps = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.disabled = false
        props.value = this.props.entity.NewVersion.StartingPoint;
        props.onChange = this.onComponentChange;
        props.field.dataSourceUrl = "RecurringTask/GetStartingPoints";
        props.field.dataTextField = "Title";
        props.field.dataValueField = "Value";
        props.field.model = "StartingPoint";
        props.field.defaultValue = 1;
        props.required= true;
        return props;
    }
    private getRoundStartToUnitProps = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.disabled = false;
        props.value = this.props.entity.NewVersion.RoundStartToUnit;
        props.onChange = this.onComponentChange;
        props.field.dataSourceUrl = "RecurringTask/GetPeriodUnits";
        props.field.dataTextField = "Title";
        props.field.dataValueField = "Value";
        props.field.model = "RoundStartToUnit";
        props.field.defaultValue = 1;
        props.required= true;
        return props;
    }

    private getWorkPackageProps = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.disabled = false
        props.value = this.props.entity.NewVersion.WorkPackageId;
        props.onChange = this.onComponentChange;
        props.dataSource = this.props.dataSources.workpackageDs;
        props.field.dataTextField = "Value";
        props.field.dataValueField = "Key";
        props.field.refreshDSOnRefChange = true;
        props.field.model = "WorkPackageId";
        props.required= true;
        return props;
    }
    private getPeriodeProps = () => {
        const props = this.factory.getDefaultNodaPeriodNumericProps();
        props.field.readOnly = false
        props.disabled = false;
        props.value = this.props.entity.NewVersion.Period;
        props.onChange = this.onComponentChange;
        props.field.model = "Period";
        props.field.defaultValue = 1;
        props.required= true;
        return props;
    }

    private onComponentChange = (field, value) => {
        let copyEntity = JSON.parse(JSON.stringify(this.props.entity));
        switch (field.model) {
            case "NewVersionValidFrom":
                copyEntity.NewVersionValidFrom = value;
                Helper.updateEntity(this.props.entity, copyEntity);
                this.common.setEntityDirtyState(true);
                break;
            case "StartingPoint":
                copyEntity.NewVersion.StartingPoint = value;
                Helper.updateEntity(this.props.entity, copyEntity);
                this.common.setEntityDirtyState(true);
                break;
            case "RoundStartToUnit":
                copyEntity.NewVersion.RoundStartToUnit = value;
                Helper.updateEntity(this.props.entity, copyEntity);
                this.common.setEntityDirtyState(true);
                break;
            case "Period":
                copyEntity.NewVersion.Period = value;
                Helper.updateEntity(this.props.entity, copyEntity);
                this.common.setEntityDirtyState(true);
                break;
            case "WorkPackageId":
                copyEntity.NewVersion.WorkPackageId = value;
                Helper.updateEntity(this.props.entity, copyEntity);
                this.common.setEntityDirtyState(true);
                break;
            case "TriggerOnInit":
                copyEntity.TriggerOnInit = value;
                Helper.updateEntity(this.props.entity, copyEntity);
                this.common.setEntityDirtyState(true);
                break;
        }

    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    render() {
        const rules = Array(3).fill(this.rule);
        let component = (
            <FullHeightContainer>
                <Menu enableMenuItem={this.common.evalAction} entries={this.menuDataSource} onSelect={this.common.evalAction} handleEval={this.common.evalAction} />
                <GridLayout config={rules}>
                    <Region renderHeader={true} title={Helper.getTranslation("WebCRM.Tasks.ExecuteAll.Cycle")} size={[{ container: "extralarge", width: "6/12" }]}>
                        <FieldInstance noLabel={true}>
                            <label style={{ marginLeft: '5px' }}>{Helper.getTranslation("Field.fstasks.LastExecutionOn").replace("{Date}", kendo.toString(kendo.parseDate(this.props.entity.PrevVersionLastExecuted), 'd') + ' (#' + this.props.entity.TriggeredCount + ')')} </label>
                        </FieldInstance>
                        <FieldInstance required={true} label={Helper.getTranslation("Field.fstasks.VersionValid")}>
                            <DatePicker  {... this.getDatePickerScheduledFor()} />
                        </FieldInstance>
                        <FieldInstance label={Helper.getTranslation("Field.fstasks.ExecutionTo")}>
                            <CheckBox  {... this.getTriggerOnInitProps()} />
                        </FieldInstance>
                        <FieldInstance required={true} label={Helper.getTranslation("Field.fstasks.StartingPoint")}>
                            <DropDownList  {... this.getStartingPointProps()} />
                        </FieldInstance>
                        <FieldInstance required={true} label={Helper.getTranslation("WebCRM.Tasks.RecurringTask.WorklogInterval")}>
                            <NodaPeriodeNumericTextBox  {... this.getPeriodeProps()} />
                        </FieldInstance>
                        <FieldInstance required={true} label={Helper.getTranslation("Field.fstasks.RoundStartToUnit")}>
                            <DropDownList  {... this.getRoundStartToUnitProps()} />
                        </FieldInstance>
                        <FieldInstance required={true} label={Helper.getTranslation("WebCRM.Tasks.Title.Workpackage")}>
                            <DropDownList  {... this.getWorkPackageProps()} />
                        </FieldInstance>
                    </Region>
                </GridLayout>
            </FullHeightContainer>);
        return component;
    }
}
export interface EditReccurenceSchemaProps extends AppBaseProps {
    entity: EditRecurrenceSchemaEntity;
    context: EditReccurenceSchemaAppContext,
    dataSources: {
        workpackageDs: any;
    }
}
interface EditReccurenceSchemaAppContext extends Context {
}

export interface EditRecurrenceSchemaEntity extends Entity {
    TriggeredCount: number;
    NewVersion: RecurrenceSchemaAllXList;
    ChainIndex: number;
    TriggerOnInit: boolean;
    PrevVersionLastExecuted: string;
    PrevVersionExecutions: number;
    NewVersionValidFrom: string;
}
interface RecurrenceSchemaAllXList {
    StartingPoint: number;
    RoundStartToUnit: number;
    Period: string;
    WorkPackageId: string;
}
